<template>
	<div id="wf-tour-incoming-json-wrapper" class="wrapper fade-in">
		<div class="actionsContainer">
			<el-tooltip content="Copy to clipboard" placement="top">
				<el-button
					@click="copyData()"
					type="text"
					icon="el-icon-document-copy"
					style="font-size: 16px;"
				></el-button>
			</el-tooltip>
		</div>
		<el-tabs v-model="activeTab">
			<el-tab-pane label="JSON Data" name="json">
				<div id="wf-tour-incoming-json-data" v-loading="!mounted" class="tabContent">
					<vue-json-pretty
						:showIcon="true"
						@node-click="
							(e) => {
								propertyClick(e, 'json');
							}
						"
						:showLength="true"
						style="padding-bottom: 20px"
						:data="returnJson"
						:collapsedOnClickBrackets="false"
						:showLine="true"
						rootPath="root"
						v-if="mounted"
					/>
				</div>
			</el-tab-pane>
			<el-tab-pane label="Binary Data" name="binary">
				<div v-loading="!mounted" class="tabContent">
					<vue-json-pretty
						@node-click="
							(e) => {
								propertyClick(e, 'binary');
							}
						"
						:showIcon="true"
						:showLength="true"
						style="padding-bottom: 20px"
						:data="returnBinary"
						:collapsedOnClickBrackets="false"
						:showLine="true"
						rootPath="root"
						v-if="mounted"
					/>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import { mapActions } from "vuex";
export default {
	components: {
		VueJsonPretty,
	},
	props: {
		integration: Object,
	},
	computed: {
		returnJson() {
			if (this.integration) {
				return this.integration.inputData
					.map((each) => {
						return each.json;
					})
					.filter((each) => {
						if (each) {
							return each;
						}
					});
			} else {
				return [];
			}
		},
		returnBinary() {
			if (this.integration) {
				return this.integration.inputData
					.map((each) => {
						return each.binary;
					})
					.filter((each) => {
						if (each) {
							return each;
						}
					});
			} else {
				return [];
			}
		},
	},
	data() {
		return {
			activeTab: "json",
			mounted: false,
		};
	},
	mounted() {
		setTimeout(() => {
			this.mounted = true;
		}, 500);
	},
	methods: {
		...mapActions(["updateReferencePathMETHOD"]),
		propertyClick(property, dataCollection) {
			if (property.path !== "root" && !/^\[\d+]$/.test(property.path)) {
				const pattern = /^\[\d+]\.?/;
				const stripedPath = property.path.substring(4).replace(pattern, (match, index) => {
					if (index === 0) {
						return "";
					}
					return match;
				});
				this.updateReferencePathMETHOD(
					dataCollection + (!stripedPath[0] || stripedPath[0] === "[" ? "" : ".") + stripedPath
				);
			}
		},
		async copyData() {
			try {
				const dataToCopy = this.activeTab === 'json' ? this.returnJson : this.returnBinary;
				await navigator.clipboard.writeText(JSON.stringify(dataToCopy, null, 4));
				this.$notify({
					title: "Success",
					message: "Data copied to clipboard!",
					type: "success",
					position: "bottom-right",
				});
			} catch (err) {
				this.$notify({
					title: "Error",
					message: "Failed to copy data",
					type: "error",
					position: "bottom-right",
				});
			}
		},
	},
};
</script>

<style scoped>
.wrapper {
	padding: 20px;
	position: relative;
}

.tabContent {
	overflow: scroll;
	height: calc(100vh - 220px);
	padding-right: 20px;
	padding-top: 20px;
}

.wrapper /deep/ .el-tabs__header {
	margin-bottom: 0px !important;
}

.wrapper /deep/ .addProperty {
	margin-left: auto;
	margin-right: 5px;
}

.actionsContainer {
	position: absolute;
	right: 20px;
	top: 18px;
	z-index: 10;
	display: flex;
	align-items: center;
}
</style>
